import React from 'react';
import { ActiveTabProvider } from '../contexts/ActiveTabContext';
import { UnsavedChangesProvider } from '../contexts/UnsavedChangesContext';

/**
 * AppProviders - Composes all global context providers
 *
 * This centralizes provider composition for better maintainability.
 * Add new global providers here instead of nesting them in App.js.
 *
 * Provider order matters - providers higher in the tree can access
 * providers lower in the tree, but not vice versa.
 */
export const AppProviders = ({ children }) => {
  return (
    <ActiveTabProvider>
      <UnsavedChangesProvider>{children}</UnsavedChangesProvider>
    </ActiveTabProvider>
  );
};
